import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import {
  AvatarContainer,
  Divider,
  Heading,
  ModalContent,
  ProfileContainer,
  RadioButton,
  TemplateOptionV1,
  Button,
  CharacterCount,
  Label,
  RadioButtonWrapper,
  StyledModal,
  LeftContent,
  FieldTitle,
  ManagerIconContainer,
  TemplateContainerNew,
  TemplateImageWrapper,
  PreviewOverlay,
  PreviewButton,
  TemplateScrollContainer,
  UserOverlay,
  UserCircle,
  UserNameOverlay
} from "../Manager/styles";
import LazyImage from "../common/LazyImage/LazyImage";
import {
  ManagerCloseIcon,
  ManagerEmojiIcon,
  ManagerLeftArrowIcon,
  PasswordEyeIcon,
} from "../../utils/icons";
import { toast } from "react-toastify";
import {
  GetTemplatesForBirthdayAndAnniversary,
  AddInspirationPost,
} from "../../redux/constants/apiConstants";
import isNull from "lodash/isNull";
import isUndefined from "lodash/isUndefined";
import { fetchApi, getReceiverNameColor } from "../../utils/methods";
import ToastMessage from "../Manager/ToastMessage";
// import { matches } from "lodash";
import {ImageUrl} from "../../utils/constants";
import SocialFeedsEmojiPicker from "../SocialFeedsEmojiPicker";
import { getInitials } from "../../utils/methods";
import { UserInitialsMain } from "./styles";
import TemplatePreviewPopup from "./TemplatePreviewPopup";
import { GetTeamMembersData } from "../../redux/constants/apiConstants";
import {
  UserContainer,
  UserDropdownContainer,
  ProfilePicture,
  DropDownStyledImage,
  ListDropdown,
} from "../SocialFeedsV2/styles";
import { NameInitials } from "../Manager/styles";
import Image from "../Image";


const TemplateSelctionModal = ({
  show,
  onClose,
  modalData,
  recognitionType,
  loggedInUser,
  type_id,
  onPostSuccess,
  companyId
}) => {
  const [page, setPage] = useState(1);
  const [charColor, setCharColor] = useState("#BDBDBD");
  const [templateData, setTemplateData] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [displayEmoji, setDisplayEmoji] = useState();
  false;
  const [emojiData, setEmojiData] = useState(null);
  const [emojiId, setEmojiId] = useState(null);
  const [emojiNative, setEmojiNative] = useState(null);
  const [emojiSkin, setEmojiSkin] = useState(null);
  // const [recipient, setRecipient] = useState("");
  const [showSuggestor, setShowSuggestor] = useState(false);
  const [filteredUsers, setFilteredUsers] = useState([]);
  // const [searchUser, searchUserName] = useState("");
  const [getUserId, setUserIdData] = useState([]);
  const [description, setDescription] = useState("");
  const [position, setPosition] = useState({ start: 0, end: 0 });
  const maxChars = 3000;
  const emojiref = useRef(null);
  const myref = useRef(null);
  const textareaRef = useRef(null);
  const [showToast, setShowToast] = useState(true);
  const [previewTemplate, setPreviewTemplate] = useState(null);

  window.console.log(" are", emojiData, emojiId, emojiNative, emojiSkin);

  const handleTemplateSelect = (id) => {
    setSelectedTemplate(id);
  };

  const handleEmojiClick = (event) => {
    if (
      !isNull(emojiref) &&
      !isUndefined(emojiref) &&
      !(emojiref && emojiref.current && emojiref.current.contains(event.target))
    ) {
      setDisplayEmoji(false);
    }
  };

  const handleClick = (event) => {
    if (
      !isNull(myref) &&
      !isUndefined(myref) &&
      !isNull(myref.current) &&
      !isUndefined(myref.current) &&
      !(myref && myref.current && myref.current.contains(event.target))
    ) {
      // this.setState({ showConnectDevice: false });
    }
  };
  window.console.log("-",showToast)
  useEffect(() => {
   
    const timer = window.setTimeout(() => setShowToast(false), 3000); 
    return () => window.clearTimeout(timer);
  }, []);


  useEffect(() => {
    document.addEventListener("mousedown", handleClick);
    document.addEventListener("mousedown", handleEmojiClick);
    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("mousedown", handleEmojiClick);
    };
  }, []);

  useEffect(() => {
    if (description.length >= 3000) {
      setCharColor("#F3384A");
    } else {
      setCharColor("#BDBDBD");
    }
  }, [description]);

  useEffect(() => {
    fetchTemplateData();
  }, []);


  useEffect(() => {
    if (modalData) {
      const memberId = modalData?.uid || modalData?.member_id;
      if (memberId) {
        setUserIdData([memberId]);
      }
    }
  }, [modalData]);

  

  const fetchTemplateData = async () => {
    const apiUrl = `${GetTemplatesForBirthdayAndAnniversary}/${type_id}`;
    try {
      const res = await fetchApi(apiUrl, "GET");
      if (res.status === "success") {
        setTemplateData(res.data);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      window.console.error(error);
    }
  };

  const showEmojiPicker = () => {
    setDisplayEmoji((prev) => !prev);
  };

  const hideEmojiPicker = () => {
    setDisplayEmoji(false);
  };



  const getTeamMemberDetails = async (search) => {
    const postData = {
      company_id: companyId,
      name: search || "",
      limit: 10,
    };
    try {
      const res = await fetchApi(GetTeamMembersData, "POST", postData);
      if (res.status === "success") {
        // setRecipient(res?.data?.response);
        setFilteredUsers(res?.data?.response);
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      window.console.error(error);
    }
  };


  const addUserText = (user) => {
    const updatedDescription = description.replace(/@(\w*)$/, `@${user.fullname} `);
    setDescription(updatedDescription);
    setShowSuggestor(false);
    textareaRef.current.focus();
  };

  const addDescription = (e) => {
    const text = e.target.value;
    if (text.length <= 3000) {
      let position = getPosition(e.target);
      setPosition(position);
      setDescription(text);
      adjustHeight();
    } else {
      const position = getPosition(e.target);
      setPosition(position);
      setDescription(text.slice(0, 3500));
      adjustHeight();
    }
  
    const match = text.match(/@(\w*)$/);
    if (match) {
      const searchTerm = match[1];
      getTeamMemberDetails(searchTerm);
      setShowSuggestor(true);
    } else {
      setShowSuggestor(false);
    }
  };

  const adjustHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "inherit";
      textarea.style.height = `${textarea.scrollHeight}px`;
      if (textarea.scrollHeight > 500) {
        textarea.style.height = "500px";
      }
    }
  };



  const containsDefaultPng = (str) => {
    const defaultPngFound = str?.includes("default.png")||!str;
    return defaultPngFound;
  }
  

  const getPosition = (el) => {
    let start = 0,
      end = 0,
      normalizedValue,
      range,
      textInputRange,
      len,
      endRange;

    if (
      typeof el.selectionStart == "number" &&
      typeof el.selectionEnd == "number"
    ) {
      start = el.selectionStart;
      end = el.selectionEnd;
    } else {
      range = document.selection.createRange();

      if (range && range.parentElement() == el) {
        len = el.value.length;
        normalizedValue = el.value.replace(/\r\n/g, "\n");
        textInputRange = el.createTextRange();
        textInputRange.moveToBookmark(range.getBookmark());
        endRange = el.createTextRange();
        endRange.collapse(false);

        if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
          start = end = len;
        } else {
          start = -textInputRange.moveStart("character", -len);
          start += normalizedValue.slice(0, start).split("\n").length - 1;

          if (textInputRange.compareEndPoints("EndToEnd", endRange) > -1) {
            end = len;
          } else {
            end = -textInputRange.moveEnd("character", -len);
            end += normalizedValue.slice(0, end).split("\n").length - 1;
          }
        }
      }
    }

    return {
      start: start,
      end: end,
    };
  };

  const addInspirationV2 = (e) => {
    // Create the new description with the added text
    const newText =
      description.slice(0, position.start) +
      e +
      description.slice(position.end);

    // Update the position and description state
    setPosition((prevPosition) => ({
      start: prevPosition.start + e.length,
      end: prevPosition.end + e.length,
    }));
    setDescription(newText);
  };

  const onEmojiSelect = (emoji, id, native, skin) => {
    // Update the state with the selected emoji data
    setEmojiData(emoji);
    setEmojiId(id);
    setEmojiNative(native);
    setEmojiSkin(skin);

    addInspirationV2(native);
  };

  const handleNext = () => {
    if (page === 1) setPage(2);
  };

  const handleBack = () => {
    if (page === 2) setPage(1);
  };

  const handlePost = () => {
    let recognitionPostDetails = {
      post_images: [],
      description: description,
      recognition_recipients:getUserId,
      core_value_id: recognitionType === "birthday" ? 19 : recognitionType === "anniversary" ? 20  : null,
      title: "",
      post_template_id: recognitionType === "birthday" ||   recognitionType === "anniversary" ? selectedTemplate : null,
      type_id :recognitionType === "birthday" ? 4 : recognitionType === "anniversary" ? 5  : 1,
      visibility:"public"
    };
    if( recognitionType === "birthday" ||   recognitionType === "anniversary"){
      recognitionPostDetails.wish_recipients = getUserId;
      recognitionPostDetails.wish_send_to = "user";

      delete recognitionPostDetails.recognition_recipients;
      delete recognitionPostDetails.core_value_id;
    }

    createPost(recognitionPostDetails);
    onClose();
  };



  const createPost = async (payload) => {
    const postData = {
      ...payload,
      title: "",
    };
    try {
      const res = await fetchApi(AddInspirationPost, "POST", postData);
      if (res.data.message) {
        toast.error(res.data.message);
      } else {
        // toast.success(res.data[0]);
        toast(
          <ToastMessage
            title="Successfully Posted"
            message="Your post has been successfully posted on your social feed."
          />,
          {
            position: "top-right",
            autoClose: 3000, 
            closeButton: false, 
            hideProgressBar: true,
            pauseOnHover: true,
            draggable: true,
            zIndex:900000,
            style: {
              right: "165px", 
              top: "46px", 
              marginRight:'20px',
              backgroundColor: "transparent", 
              boxShadow: "none", 
              width:'510px',
            },
          },
        );
        if (onPostSuccess) {
          onPostSuccess();
        }
      }
    } catch (error) {
      // toast.error(error)
    }
  };

  return (
    <>
      <StyledModal id="recognition-modal"    
        show={show && !previewTemplate}  
        onHide={onClose} 
        centered width="800px">
        <ModalContent isPadding={"16px 0 12px 0"} id="recognition-modal-content"  isHeight={"600px"} /*isHeight={recognitionType === "recognition" ?  "800px" : "565px"}*/
        >
          <div
            id="modal-header-container"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding:"0px 24px"
            }}
          >
            <Heading id="recognition-modal-heading">
              {recognitionType === "recognition"
                ? "Give a Recognition"
                : recognitionType === "birthday"
                  ? "Celebrating a Birthday"
                  : "Celebrating a Work Anniversary"}
            </Heading>
            <ManagerIconContainer id="modal-icons" isWidth={'32px'} isHeight={'32px'} style={{ cursor: "pointer" }} onClick={onClose}>
              {ManagerCloseIcon()}
            </ManagerIconContainer>
          </div>
          <Divider id="modal-divider" isMargin={"16px 0px"}></Divider>
          <ProfileContainer id="modal-profile">
            <AvatarContainer isProfile={true} id="modal-avatar">
              {!containsDefaultPng(loggedInUser?.profile_image) ?
                <LazyImage
                  style={{
                    width: "60px",
                    height: "60px",
                    borderRadius: "40px",
                    border: "1px solid #DCDCDC",
                  }}
                  onError={() => window.console.error("Image failed to load")}
                  src={`${ImageUrl}/${loggedInUser?.profile_image}`}
                />
                :
                <UserInitialsMain border isBg isWidth={"60px"} isHeight={"60px"} size="24px">{`${getInitials(loggedInUser?.fname)}${getInitials(loggedInUser?.lname)}`}</UserInitialsMain>}
            </AvatarContainer>
            <div>{`${loggedInUser?.fname} ${loggedInUser?.lname}`}</div>
          </ProfileContainer>
  
          {page === 1 && (
            <>
              {recognitionType === "birthday" ||
              recognitionType === "anniversary" ? (
                  <>
                    <FieldTitle color={"#184A61"}  id="field-title" marginTop={"24px"} isFont={"Lato"}>
                      {"Select Template"}
                    </FieldTitle>
                    <div
                      id="template-scroll-container"
                      style={{
                        overflowY: "auto",
                        padding: "16px 24px 12px 24px",
                        scrollbarWidth: "thin",
                        scrollbarColor: "#BDBDBD #fff",
                      }}
                    >
                      <TemplateScrollContainer id="template-scroll-container">
                        <TemplateContainerNew id="template-container">
                          {templateData?.map((template, index) => (
                            <TemplateOptionV1 isGap={"0 40px"} key={template.id} id="template-option">
                              {/* Image wrapper with hover preview */}
                              <TemplateImageWrapper
                                isSelected={selectedTemplate === template.id}
                                onClick={() => handleTemplateSelect(template.id)}
                              >
                                <LazyImage
                                  style={{
                                    width: "100%",
                                    aspectRatio: "1",
                                    objectFit: "cover",
                                    display: "block",
                                    borderRadius: "3px",
                                  }}
                                  onError={() => window.console.error("Image failed to load")}
                                  src={`${ImageUrl}/${template?.image_url}`}
                                />
                                <UserOverlay>
                                  <UserCircle>
                                    {!containsDefaultPng(modalData?.profile_image) ?
                                      <img
                                        src={`${ImageUrl}/${modalData?.profile_image}`}
                                        onError={(e) => {
                                          e.target.style.display = "none";
                                        }}
                                        alt="user"
                                      />
                                      :
                                      <UserInitialsMain 
                                        isHeight={"80px"}
                                        isWidth={"80px"}
                                        isRadius={"50%"}
                                        size={"20px"}
                                        border
                                        isBg >{`${getInitials(modalData?.name)}`}</UserInitialsMain>}
                                  </UserCircle>
                                  <UserNameOverlay  isSize={"10px"} isColor={getReceiverNameColor(type_id, template.id)}>
                                    {`${modalData?.name}`}
                                  </UserNameOverlay>
                                </UserOverlay>
                                <PreviewOverlay className="preview-overlay">
                                  <PreviewButton
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setPreviewTemplate(template);
                                    }}
                                  >
                                    {PasswordEyeIcon("#ffffff")}  Preview
                                  </PreviewButton>
                                </PreviewOverlay>
                              </TemplateImageWrapper>
                              <RadioButtonWrapper isMargin={"16px 0 0 0"} id="modal-radio-options">
                                <RadioButton
                                  id="radio-buttons"
                                  type="radio"
                                  name="template"
                                  checked={selectedTemplate === template.id}
                                  onChange={() => handleTemplateSelect(template.id)}
                                />
                                <Label id="template-label">Option {index + 1}</Label>
                              </RadioButtonWrapper>
                            </TemplateOptionV1>
                          ))}
                        </TemplateContainerNew>
                      </TemplateScrollContainer>
                    </div>
                    <Button id="next-button" onClick={handleNext} disabled={!selectedTemplate}>
                      Next{" "}
                    </Button>
                  </>
                ) : null}
            </>
          )}
          {page === 2 && (
            <>
              <LeftContent id="left-content">
               

                <div id="text-area">
                  <textarea
                    placeholder={"Write here. You can also include @mentions."}
                    rows="3"
                    name=""
                    onChange={(e) => addDescription(e)}
                    value={description}
                    data-gramm_editor="false"
                    className="CustomTextAreaField"
                    spellCheck="false"
                    ref={textareaRef}
                    onInput={(e) => addDescription(e)}
                    onClick={(e) => addDescription(e)}
                  />
                
                  <UserContainer
                    showSuggestor={showSuggestor}
                    isManagerMargin="12px"
                    width="350px"
                  >
                    {filteredUsers.map((user, index) => (
                      <UserDropdownContainer key={index} onClick={() => addUserText(user)}>
                        <ProfilePicture>
                          <DropDownStyledImage width="100%" left height="30px">
                            <div className="middle">
                              {user?.profile_image !== "profile-Image/default.png" ? (
                                <Image image={user?.profile_image} alt={user?.fname} />
                              ) : (
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", margin: "5px 10px" }}>
                                  <NameInitials isWidth={"40px"} isHeight={"40px"} isRadius={"50%"}>
                                    {getInitials(user?.fullname)}
                                  </NameInitials>
                                </div>
                              )}
                            </div>
                            <ListDropdown
                              index={index}
                              onClick={() => addUserText(user)}
                            >
                              {user.fullname}
                            </ListDropdown>
                          </DropDownStyledImage>
                        </ProfilePicture>
                      </UserDropdownContainer>
                    ))}
                  </UserContainer>
                </div>
              </LeftContent>
              <div
                id="emoji-container"
                style={{
                  width: "752px",
                  height: "32px",
                  display: "flex",
                  justifyContent: "space-between",
                  margin:"16px 24px 0px 24px"
                }}
              >
                <ManagerIconContainer  id="emoji-icon" onClick={showEmojiPicker}>{ManagerEmojiIcon()}</ManagerIconContainer>
                <CharacterCount  id="char-count" style={{ color: charColor }}>
                  {description.length}/{maxChars} | C
                </CharacterCount>
              </div>
              <Divider isMargin={"16px 24px"} isWidth={"94%"}></Divider>
              <div style={{ margin: "auto", display: "flex", gap: "16px" }}>
                <Button
                  id="back-icon"
                  isBg={true}
                  onClick={handleBack}
                  color="red"
                  hoverColor="#5a6268"
                >
                  <ManagerIconContainer  id="back-icon" isWidth={'16px'} isHeight={'16px'}>{ManagerLeftArrowIcon()}</ManagerIconContainer> Back
                </Button>
                <Button  id="post-button" onClick={handlePost}  disabled={description.length > 3000}  /*disabled={!description}*/>
                  Post{" "}
                 
                </Button>
              </div>
              {displayEmoji ? (
                <SocialFeedsEmojiPicker
                  selectEmoji={onEmojiSelect}
                  emojiRef={emojiref}
                  hidePicker={hideEmojiPicker}
                />
              ) : null}
            </>
          )}
        </ModalContent>
      </StyledModal>
      {previewTemplate && (
        <TemplatePreviewPopup
          show={!!previewTemplate}
          onClose={() => setPreviewTemplate(null)}
          template={previewTemplate}
          modalData={modalData}
          loggedInUser={loggedInUser}
          type_id={type_id}
        />
      )}
    </>
  );
};

TemplateSelctionModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  modalData: PropTypes.object.isRequired,
  recognitionType: PropTypes.string.isRequired,
  loggedInUser: PropTypes.object.isRequired,
  companyId:PropTypes.number.isRequired,
  type_id:PropTypes.number.isRequired,
  onPostSuccess: PropTypes.func
};

export default TemplateSelctionModal;
